import type { HTMLAttributes } from 'react'
import React, { useState, useEffect, useMemo } from 'react'
import { intervalToDuration } from 'date-fns'

const ONE_SECOND_DELAY = 1000

const padZero = (number: number) => {
  return number.toString().padStart(2, '0')
}

const formatDuration = ({ hours = 0, minutes = 0, seconds = 0 }: Duration) => {
  const minuteHours = hours * 60

  return `${padZero(minutes + minuteHours)}:${padZero(seconds)}`
}

type ElapsedTimerProps = {
  // startTime can be a string because it is stored as a string in offline storage
  startTime: Date | string
} & HTMLAttributes<HTMLDivElement>

export const ElapsedTimer = ({ startTime, ...props }: ElapsedTimerProps) => {
  const start = useMemo(() => new Date(startTime), [startTime])

  const [duration, setDuration] = useState<Duration>(() => {
    return intervalToDuration({
      start,
      end: new Date(),
    })
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setDuration(() => {
        return intervalToDuration({
          start,
          end: new Date(),
        })
      })
    }, ONE_SECOND_DELAY)

    return () => {
      clearInterval(interval)
    }
  }, [start])

  return <span {...props}>{formatDuration(duration)}</span>
}
